/**
 * The About me field onboarding submits. Only text the user typed is sent, and
 * never a blank: onboarding has no clear gesture, and the prefill can be a
 * cached or degraded home-context read ("" when the profile read failed), which
 * must never overwrite or clear the stored About me.
 */
export function onboardingAboutMe(
  aboutMe: string,
  edited: boolean
): { user_instructions?: string } {
  const trimmed = aboutMe.trim()
  return edited && trimmed ? { user_instructions: trimmed } : {}
}
